<template>
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4596 2.49996V1H9.95959V2.05866L6.20959 4.14203L2.45959 2.05866V1H0.959595V2.49996V2.94126L1.34536 3.15557L5.84536 5.65562L6.20959 5.85797L6.57383 5.65562L11.0738 3.15557L11.4596 2.94126V2.49996ZM11.4596 7.99996V6.5H9.95959V7.55866L6.20959 9.64203L2.45959 7.55866V6.5H0.959595V7.99996V8.44126L1.34536 8.65557L5.84536 11.1556L6.20959 11.358L6.57383 11.1556L11.0738 8.65557L11.4596 8.44126V7.99996Z"
      fill="#666666"
    />
  </svg>
</template>

<script setup></script>
